angular.module('calendarApp').directive('footerVersion', footerVersion);

function footerVersion() {
  return {
    restrict: 'EA',
    replace: true,
    template: '<div class="footer-version">v{{version}}</div>',
    link: function link(scope, elem, attrs) {
      scope.version = process.env.VERSION;
    }
  };
}